module.exports = __webpack_public_path__ + "static/assets/306b05712437d6b9a28ed0db73794fd5.svg";